import posterBg from '../../../assets/img/Autumn_season.png';
import { BRAND, CampaignLogo } from './KhareefBrand';

/** The six-step participation flow, same order as the portal posters. */
const STEPS = [
  'دخول صفحة المشاركة',
  'تعبئة نموذج المشاركة',
  'إرسال المشاركة',
  'مراجعة المشاركة',
  'اعتماد المشاركة',
  'نشر الصورة',
];

/** Decorative QR stand-in, matching the portal's placeholder artwork. */
function QrBox() {
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full" aria-hidden="true">
      <rect width="100" height="100" fill="#fff" />
      <g fill={BRAND.teal}>
        <rect x="8" y="8" width="26" height="26" />
        <rect x="14" y="14" width="14" height="14" fill="#fff" />
        <rect x="66" y="8" width="26" height="26" />
        <rect x="72" y="14" width="14" height="14" fill="#fff" />
        <rect x="8" y="66" width="26" height="26" />
        <rect x="14" y="72" width="14" height="14" fill="#fff" />
        <rect x="44" y="10" width="6" height="6" />
        <rect x="52" y="18" width="6" height="6" />
        <rect x="44" y="26" width="6" height="6" />
        <rect x="62" y="44" width="6" height="6" />
        <rect x="72" y="52" width="6" height="6" />
        <rect x="80" y="44" width="6" height="6" />
        <rect x="44" y="52" width="6" height="6" />
        <rect x="52" y="62" width="6" height="6" />
        <rect x="44" y="72" width="6" height="6" />
        <rect x="62" y="72" width="6" height="6" />
        <rect x="80" y="72" width="6" height="6" />
        <rect x="72" y="80" width="6" height="6" />
      </g>
    </svg>
  );
}

/**
 * The two campaign posters shown at the foot of the public page:
 * "بوستر دليل المشاركة" and "بوستر اعلان المبادرة".
 */
export default function KhareefPosters() {
  return (
    <section dir="rtl" className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Participation guide */}
      <div>
        <p className="text-center font-bold mb-3" style={{ color: BRAND.purple }}>
          بوستر دليل المشاركة
        </p>
        <article
          className="rounded-2xl p-6 text-white h-full flex flex-col items-center"
          style={{ backgroundColor: BRAND.teal }}
        >
          <CampaignLogo size="sm" />
          <p className="text-sm mt-3 opacity-90">من خلال موقعنا الإلكتروني</p>
          <h3 className="text-lg font-bold mt-4 mb-4 text-center">
            دليل المشاركة في الموقع الإلكتروني
          </h3>

          <ol className="w-full space-y-2">
            {STEPS.map((label, i) => (
              <li
                key={label}
                className="flex items-center gap-3 rounded-lg px-3 py-2"
                style={{ backgroundColor: 'rgba(255,255,255,0.10)' }}
              >
                <span
                  className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold"
                  style={{ backgroundColor: BRAND.yellow, color: BRAND.purple }}
                >
                  {i + 1}
                </span>
                <span className="text-sm">{label}</span>
              </li>
            ))}
          </ol>
        </article>
      </div>

      {/* Campaign announcement */}
      <div>
        <p className="text-center font-bold mb-3" style={{ color: BRAND.purple }}>
          بوستر اعلان المبادرة
        </p>
        <article
          className="rounded-2xl p-6 text-white h-full flex flex-col items-center justify-between"
          style={{
            backgroundImage: `linear-gradient(160deg, ${BRAND.teal72}, ${BRAND.tealSolid}), url(${posterBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: 340,
          }}
        >
          <CampaignLogo size="md" />
          <p className="text-sm mt-3 opacity-90">من خلال موقعنا الإلكتروني</p>

          <div className="flex flex-col items-center mt-5">
            <div className="w-24 h-24 rounded-lg overflow-hidden bg-white p-1">
              <QrBox />
            </div>
            <span className="text-xs mt-2 opacity-90">صفحة المشاركة QR</span>
          </div>
        </article>
      </div>
    </section>
  );
}
